/**
 * Legacy-login only version: removes Shop (one-time code) login UI.
 * Paste this over assets/account-login-actions.js.
 * Make sure your login template still includes this script tag.
 */
class AccountLoginActions extends HTMLElement {
  connectedCallback() {
    // 1) Remove any Shop login buttons so passwordless flow can't trigger
    this.querySelectorAll('shop-login-button').forEach((btn) => {
      const placeholder = document.createComment('shop-login-button removed for legacy login');
      btn.replaceWith(placeholder);
    });

    // 2) Unhide the classic email+password form if the theme had hidden it
    //    Adjust selectors if your theme uses different markup/classes.
    const classicForm =
      this.querySelector('form[action="/account/login"]') ||
      document.querySelector('form[action="/account/login"]');

    if (classicForm) {
      classicForm.removeAttribute('hidden');
      classicForm.classList.remove('hidden', 'is-hidden', 'visually-hidden');
      // If the form fields were disabled by theme JS, re-enable them
      classicForm.querySelectorAll('input, button, select, textarea').forEach(el => {
        el.disabled = false;
      });
    }
  }
}

if (!customElements.get('account-login-actions')) {
  customElements.define('account-login-actions', AccountLoginActions);
}
